import { defineMessages } from 'react-intl'

export default defineMessages({
  expiredMessage: {
    id: 'Redeem.start.expiredMessage',
    defaultMessage: 'We’re sorry but the code has expired.',
  },
  invalidMessage: {
    id: 'Signup.invalidCode',
    defaultMessage: 'Sorry, the code is invalid.',
  },
  codeApplied: {
    id: 'SignUp.codeApplied',
    defaultMessage: 'Code applied!',
  },
  aboutYou: {
    id: 'progress_indicator_about_you',
    defaultMessage: 'About you',
  },
  account: {
    id: 'progress_indicator_account',
    defaultMessage: 'Account',
  },
  subscription: {
    id: 'progress_indicator_subscription',
    defaultMessage: 'Subscription',
  },
  done: {
    id: 'progress_indicator_done',
    defaultMessage: 'Done',
  },
})
